import { readContract, erc20ABI } from "@wagmi/core"
import { BigNumber } from "ethers"
import { type Address } from "viem"

export const getBalanceAsync = async (
  address: Address,
  tokenAddress: Address,
): Promise<BigNumber> => {
  if (!address || !tokenAddress) return Promise.resolve(BigNumber.from(0))

  return readContract({
    address: tokenAddress,
    abi: erc20ABI,
    functionName: "balanceOf",
    args: [address],
  })
}
